module.exports = __webpack_public_path__ + "2c6ca41f217da4c3b513a9b523bfd701.pdf";